





























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { User } from '@/modules/backend/Entities/User';

const AuthModule = namespace('app/auth');

@Component
export default class UserProfileMenu extends Vue {
  @AuthModule.Getter('Info')
  private AuthInfo!: User;

  @AuthModule.Action('LogOut')
  private AuthLogOut!: () => Promise<void>;

  public get username(): string {
    const username = this.AuthInfo.getName();

    if (username) {
      const firstName = username.getFirst();
      const lastName = username.getLast();
      const patronymic = username.getPatronymic();

      if (firstName && lastName && patronymic) {
        /* Константинопольский К. К. */
        return `${lastName} ${firstName.substr(0, 1)}. ${patronymic.substr(0, 1)}.`;
      } else if (firstName && lastName) {
        /* Константин Константинопольский */
        return `${firstName} ${lastName}`;
      }
    }

    /* k.konst@example.com */
    return this.AuthInfo.getEmail();
  }

  public get usernameAbbr(): string | undefined {
    const username = this.AuthInfo.getName();
    if (username) {
      const firstName = username.getFirst();
      const lastName = username.getLast();

      if (firstName && lastName) {
        return `${firstName.substr(0, 1)}${lastName.substr(0, 1)}`;
      }
    }

    return undefined;
  }

  private async logout(): Promise<void> {
    await this.AuthLogOut();
    await this.$router.push({ name: 'login' });
  }
}
